<template>
  <div>
    <BlockHeader name="Reports / E-Mail notifications" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 col-xs-12 p-0">
        <div class="col-lg-6 col-sm-12 col-xs-12">
          <Input v-model="settingsLocal.reports_email_sender" form-group-id="Sender" placeholder="Sender" />
        </div>
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.reports_email_recipient" form-group-id="Recipient" placeholder="Recipient" />
      </div>
      <div class="col-lg-6 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.reports_email_cc" form-group-id="CC" placeholder="CC's" />
      </div>
      <div class="col-lg-12 col-sm-12 col-xs-12">
        <Input v-model="settingsLocal.reports_email_subject" form-group-id="Subject" placeholder="Subject" />
      </div>
      <div class="col-lg-12 col-sm-12 col-xs-12">
        <Textarea v-model="settingsLocal.reports_email_text" form-group-id="E-Mail Text" placeholder="E-Mail Text" />
        <div>
          {{ 'You can use dynamic variables in the email template' | i18n }}<br />
          {{ 'Example' | i18n }}:<br />
          {{ 'PDF Name' | i18n }} - {pdfName}<br />
          {{ 'Case Number' | i18n }} - {caseNumber}<br />
          {{ 'Case title' | i18n }} - {title}<br />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Textarea from '../../../../../common/textarea/index';
import Input from '../../../../../common/input/index';
import BlockHeader from '../../../../../common/block-header';

export default {
  name: 'Email',
  components: { Input, BlockHeader, Textarea },
  props: {
    settings: {
      type: Object,
      default: () => {}
    }
  },
  data: function() {
    return {};
  },
  computed: {
    settingsLocal: {
      get: function() {
        return this.settings;
      },
      set: function(value) {
        this.$emit('settings', value);
      }
    }
  }
};
</script>
